import React, { Component } from 'react';
import _ from 'lodash';

import ParkinglocationTable from '../components/ParkinglocationTable';
import ParkinglocationForm from '../components/ParkinglocationForm';

import ParkinglocationModel from '../components/ParkinglocationModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class SettingsParkinglocationsScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    parkinglocationFormModalVisible: false,
    parkinglocationFormDefaultValues: null,
  }

  componentWillMount() {
    this.loadData();
  }

  loadData(force = false) {
    this.setState({
      dataLoading: true
    });
    ParkinglocationModel.getAll(force)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      });
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => { return d['Name'].startsWith(searchText); })
    })
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Systém - Seznam lokalit</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="Název lokality"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData(true) }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { window.open('/editor-system-locations.html', '_blank'); }} style={{ marginRight: 10 }}>Otevřít editor</Button>
                  : null}
                {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ parkinglocationFormModalVisible: true }) }}>Nová lokalita</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <ParkinglocationForm
            type="modal"
            modalVisible={this.state.parkinglocationFormModalVisible}
            defaultValues={this.state.parkinglocationFormDefaultValues}
            onModalCancel={(form) => {
              form.resetFields();
              this.setState({
                parkinglocationFormModalVisible: false,
                parkinglocationFormDefaultValues: null
              });
            }}
            onSuccess={(form, values) => {
              ParkinglocationModel.create(values)
                .then(() => {
                  message.success('Lokalita byla vložena!');
                  form.resetFields();
                  this.setState({
                    parkinglocationFormModalVisible: false,
                    parkinglocationFormDefaultValues: null
                  });
                  this.loadData(true);
                });
            }} />
          <ParkinglocationTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onDetailRow={(record) => {
              this.setState({
                parkinglocationFormModalVisible: true,
                parkinglocationFormDefaultValues: record
              });
            }}
            onRemoveRow={(id) => {
              ParkinglocationModel.remove(id)
                .then(() => {
                  this.loadData(true);
                });
            }}
            onAnyFormSuccess={() => {
              this.loadData(true);
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default SettingsParkinglocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/SettingsParkinglocationsScreen.js